export enum InvoiceType {
    Unknown = 'Unknown',
    Income = 'Income',
    Expenses = 'Expenses',
    InternalIncome = 'InternalIncome',
    Attribution = 'Attribution',
}
